import React, {useEffect, useState} from "react";
import {addDoc, collection} from "firebase/firestore"
import { db, auth } from "../firebase-config";
import {useNavigate} from "react-router-dom";
import '../App.css';

function CreatePost(isAuth) {
    const [title, setTitle] = useState("");
    const [Desc, setDesc] = useState("");

    const postsCollectionRef = collection(db, "Posts");
    let navigate = useNavigate();
    const createPost = async () => {
        await addDoc(postsCollectionRef, {
            title: title,
            description: Desc,
            name: auth.currentUser.displayName, 
            id: auth.currentUser.uid,
            submit: []
        });
        navigate("/");
    }

    useEffect(() =>{
        if (!isAuth){
            navigate("/Login");
        }
    }, [isAuth, navigate])

    return (
        <div className = "App">
            <div className="module">
                <h1 className="title">
                    Create A Post
                </h1>
                
                    <h3 className="name">TITLE </h3>
                    
                    <input className="area" placeholder="Title.." onChange ={(event)=>{
                        setTitle(event.target.value);
                    }}/>
                
                <div className="inputGp">
                    <h3 className="name">DESCRIPTION: </h3>
                    <textarea className="area" placeholder="Description.." onChange={(event)=>{
                        setDesc(event.target.value);
                    }}/>
                </div>
                <button className="delete" onClick = {createPost}>SUBMIT TASK</button>
            </div>
            
        </div>
    )
}

export default CreatePost;